import { useEffect, useMemo, useState } from 'react';
import { Link } from '@chakra-ui/react';

const RESEND_OTP_COOLDOWN = 30;

export enum OTPType {
  SMS = 'SMS',
  EMAIL = 'email',
}

interface ResendOTPProps {
  type: OTPType;
  onResend?: () => void;
  short?: boolean;
}

export default function ResendOTP({ type, onResend, short = false }: ResendOTPProps) {
  const [counter, setCounter] = useState(RESEND_OTP_COOLDOWN);

  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => setCounter(counter - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [counter]);

  const handleResend = () => {
    if (counter === 0) {
      onResend?.(); // Trigger the resend logic (API call, etc.)
      setCounter(RESEND_OTP_COOLDOWN); // Start countdown
    }
  };

  const resendText = useMemo(() => {
    if (counter > 0) {
      return short ? `Resend in ${counter}s` : `Didn't receive an ${type}? Resend in ${counter}s`;
    }
    return short ? 'Resend' : `Didn't receive an ${type}? Resend`;
  }, [short, type, counter]);

  return (
    <Link
      color="#FF0050"
      onClick={handleResend}
      _hover={{ textDecoration: counter > 0 ? 'underline' : 'none' }}
      pointerEvents={counter > 0 ? 'none' : 'auto'}
    >
      {resendText}
    </Link>
  );
}
